import produce from 'immer';
import * as _ from 'lodash';

import { createReducer } from '../utils';
import { actionTypes } from './actions';
import type { JobsStore } from './types';
import type { SyncReduxAction } from '../../types';

const initialState: JobsStore = {
  jobs: {},
};

const reducer = createReducer<JobsStore>(initialState, {
  [actionTypes.ADD_JOB]: (state: JobsStore, action: SyncReduxAction<{ job: { jobToken: string; task: string; }}>) => {
    return produce(state, draftState => {
      draftState.jobs = {
        ...state.jobs,
        [action.job.jobToken]: { name: action.job.task },
      };
    });
  },
  [actionTypes.REMOVE_JOBS]: (state: JobsStore, action: SyncReduxAction<{ jobTokens: string[]; }>) => {
    return produce(state, draftState => {
      draftState.jobs = _.omit(state.jobs, action.jobTokens);
    });
  },
});

export default reducer;
